import { RampService, SlotEvent } from '../model/types';

export const PAX_COACH_DEP = 'Pax coach DEP';
export const FUELING_KG_TIME = 'Fueling Kg/Time';
export const AC_DEICING = 'A/C Deicing';

export function getRampServiceById(
  services: RampService[],
  id: string
): RampService | undefined {
  return services.find(service => service._id === id);
}

export function getRampServiceByName(
  services: RampService[],
  name: string
): RampService | undefined {
  return services.find(service => service.name === name);
}

export function getFixedRampServices(services: RampService[]): RampService[] {
  return services
    .filter(item => item.isFixed)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function getNotFixedRampServices(
  services: RampService[]
): RampService[] {
  return services.filter(item => !item.isFixed);
}

const CREW_CHANGE_SERVICES = ['ARR Crew released', 'DEP Crew reported'];

export function prepareRampServices(
  services: RampService[],
  event: SlotEvent
): RampService[] {
  const { inbound, outbound, crewChangeType } = event;
  let filteredServices = services;
  if (crewChangeType === 'backToBack') {
    filteredServices = filteredServices.filter(
      service => !CREW_CHANGE_SERVICES.includes(service.name)
    );
  }

  const isInboundContact = inbound.parkingStand === 'contact';
  const isOutboundContact = outbound.parkingStand === 'contact';

  if (!isInboundContact && !isOutboundContact) {
    filteredServices = filteredServices.filter(
      service => service.name !== 'Aerobridge'
    );
  }

  if (isInboundContact) {
    filteredServices = filteredServices.filter(
      service => service.name !== 'PAX coach ARR'
    );
  }

  if (isOutboundContact) {
    filteredServices = filteredServices.filter(
      service => service.name !== 'Pax coach DEP'
    );
  }

  if (isInboundContact && isOutboundContact) {
    filteredServices = filteredServices.filter(
      service => service.name !== 'Pax steps'
    );
  }

  if (!inbound.cargo?.length) {
    filteredServices = filteredServices.filter(
      service => service.name !== 'Cargo/Mail offloading'
    );
  }

  if (!outbound.cargo?.length) {
    filteredServices = filteredServices.filter(
      service => service.name !== 'Cargo/Mail loading'
    );
  }

  return filteredServices;
}
